import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: none;
  padding: 0 20px;

  ${up('sm')} {
    display: block;
  }
`

const Content = styled.div`
  height: 0;
  padding-bottom: 30%;
  background: #f7f8f9;
  border-radius: 10px;
`

export const Hero: ComponentType = () => (
  <Wrapper>
    <Content />
  </Wrapper>
)
